import React from "react";
import PropTypes from "prop-types";
import useWalletLabel from "../../../shared/useWalletLabel";

export default function ClassCheckoutNote(props) {
  const walletLabel = useWalletLabel(props);

  return (
    <p className="pc-rail__note">
      Secure checkout with Stripe{walletLabel && ` · ${walletLabel} supported`}
    </p>
  );
}

ClassCheckoutNote.propTypes = {
  stripePublishableKey: PropTypes.string.isRequired,
  stripeConnectedAccountId: PropTypes.string,
  paymentCountry: PropTypes.string.isRequired,
  paymentCurrency: PropTypes.string.isRequired,
};
